<template>
	<div class="">
		<div class="d-flex flex-column align-items-center justify-content-center h-full-page">
			<img :src="welcome" alt="Welcome to MyMeds" :class="width < 992 ? 'w-75' : 'w-40'"  />
			<h1 class="text-center mt-3">Account Setup Completed</h1>
			<p class="text-center text-muted mt-1">Welcome! All set <span class="text-dark fw-medium text-decoration-underline">{{ username }}</span>, you may change your settings at any time within your settings page.</p>

			<div class="d-flex flex-column py-4 gap-1 align-items-center w-100">
				<button class="btn btn-link" @click="moveButtonAction('profile')">Go to My Profile</button>
				<button class="btn btn-dark rounded-pill py-7 " :class="width < 992 ? 'w-75' : 'w-50'" @click="moveButtonAction('home')">Go to Home Page</button>
			</div>
		</div>
	</div>
</template>

<script setup>
import welcome from "@/assets/welcome.svg";
import { onMounted } from "vue";
import apiClient from "@/utils/axios.js";
import { useHttpErrorManager } from "@/composables/useHttpErrorManager.js";
import { useAuthStore } from "@/stores/auth-store.js";

const props = defineProps({
	width: [String, Number],
	username: {
		type: String,
		default: null,
		require: false
	}
});

const emits = defineEmits(['navigationButtonClicked']);

const auth = useAuthStore();
const moveButtonAction = async (name) => {
	await auth.FETCH_USER_DATA(true);
	emits('navigationButtonClicked', name);
}

onMounted(async () => {
	await markUserAccountSetupComplete();
});

const markUserAccountSetupComplete = async () => {
	try {
		const response = await apiClient.post("auth/user/account-setup-complete", {});
	} catch (error) {
		await useHttpErrorManager().handleError(error, true);
	}
}

</script>

<style scoped lang="scss">
.w-40 {
	width: 40%;
}
.h-full-page{
	height: calc(100vh - 5px);
}
</style>